import axiosInstance from '@/libs/axios'

const getInitialState = () => ({
  formCostConfig: {
    id: null,
    name: '',
    acquirer: '',
    // Percentual, NAO fracao: 1.79 significa 1,79%. A API armazena com quatro casas decimais.
    //
    // ATENCAO: nao usar o input `text-percetage` nestes campos. Aquele componente exibe o valor
    // multiplicado por 100 e grava dividido por 100, ou seja, o modelo dele e uma FRACAO. Usa-lo
    // aqui gravaria 0,0171 para 1,71%% e o custo calculado sairia 100x menor, sem erro visivel:
    // o Range(0,100) do servidor aceita 0,0171 normalmente. Use `text-number`.
    // Um conjunto completo por canal: a adquirente cobra mais caro no online, em que o cartão
    // não está presente e o risco de fraude e chargeback é maior.
    physical: {
      operationCostCashPercent: null,
      operationCostInstallmentPercent: null,
      anticipationCostMonthlyPercent: null,
    },
    online: {
      operationCostCashPercent: null,
      operationCostInstallmentPercent: null,
      anticipationCostMonthlyPercent: null,
    },
    effectiveFrom: null,
    effectiveTo: null,
    active: true,
  },
  // Valor de referência da simulação. Só existe na tela: não é salvo no cadastro.
  simulationSaleValue: 1000,
  simulationChannel: 'Physical',
  simulationLines: [],
})

export default {
  namespaced: true,
  state: getInitialState(),

  mutations: {
    SET_FORM_COST_CONFIG(state, formCostConfig) {
      state.formCostConfig = formCostConfig
    },

    SET_SIMULATION_SALE_VALUE(state, value) {
      state.simulationSaleValue = value
    },

    SET_SIMULATION_CHANNEL(state, channel) {
      state.simulationChannel = channel
    },

    SET_SIMULATION_LINES(state, lines) {
      state.simulationLines = lines
    },

    CLEAN_STATE(state) {
      const initial = getInitialState()
      state.formCostConfig = initial.formCostConfig
      state.simulationSaleValue = initial.simulationSaleValue
      state.simulationChannel = initial.simulationChannel
      state.simulationLines = initial.simulationLines
    },
  },

  actions: {
    async fetchById({ commit }, id) {
      const { data } = await axiosInstance.get(
        `/api/settings/financial/acquirer-cost-configs/${id}`
      )
      commit('SET_FORM_COST_CONFIG', data)
    },

    async saveForm({ state }) {
      const { id, name, acquirer, physical, online, effectiveFrom, effectiveTo } =
        state.formCostConfig

      await axiosInstance({
        url: id
          ? `/api/settings/financial/acquirer-cost-configs/${id}`
          : '/api/settings/financial/acquirer-cost-configs',
        method: id ? 'PUT' : 'POST',
        data: {
          id,
          name,
          acquirer,
          physical,
          online,
          effectiveFrom,
          effectiveTo,
        },
      })
    },

    /**
     * Simulação do custo financeiro de 1 até 24 parcelas.
     *
     * Chama a API em vez de calcular na tela de propósito: o cálculo de custo tem uma única
     * implementação, no backend. Reproduzi-lo no frontend criaria uma segunda fonte de verdade que
     * divergiria na primeira mudança de regra, e o operador veria um número diferente do que a
     * venda vai efetivamente aplicar.
     */
    async fetchSimulation({ commit, state }) {
      const { id } = state.formCostConfig

      if (!id) {
        commit('SET_SIMULATION_LINES', [])
        return
      }

      const { data } = await axiosInstance.get(
        `/api/settings/financial/acquirer-cost-configs/${id}/simulation`,
        {
          params: {
            saleValue: state.simulationSaleValue,
            channel: state.simulationChannel,
          },
        }
      )

      commit('SET_SIMULATION_LINES', data?.lines || [])
    },

    setSimulationSaleValue({ commit }, value) {
      commit('SET_SIMULATION_SALE_VALUE', value)
    },

    setSimulationChannel({ commit }, channel) {
      commit('SET_SIMULATION_CHANNEL', channel)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
